export default [
  {
    path: 'home',
    name: 'geo-home',
    redirect: 'home/workbench',
    component: () => import('./HomePage.vue'),
    children: [
      {
        path: 'analytical',
        name: 'home-analytical',
        redirect: '/analytical/brand',
        component: () => import('./analytical/AnalyticalPage.vue'),
        children: [
          {
            path: 'brand',
            name: 'analytical-brand',
            meta: { openWebgl: true },
            component: () => import('./analytical/pages/BrandPage.vue'),
          },
          {
            path: 'manage',
            name: 'analytical-manage',
            component: () => import('./analytical/pages/ReportManage.vue'),
          },
          {
            path: 'companyGen',
            name: 'analytical-companyGen',
            component: () => import('./analytical/pages/CompanyGen.vue'),
          },
          {
            path: 'deepInsight',
            name: 'analytical-deepInsight',
            meta: { openWebgl: true },
            component: () => import('./report/pages/DeepInsightPage.vue'),
          },
          {
            path: 'brandPortrait',
            name: 'analytical-brandPortrait',
            meta: { hightRoute: '/home/analytical/deepInsight' },
            component: () => import('./report/pages/BrandPortraitPage.vue'),
          },
          {
            path: 'dataCollection',
            name: 'analytical-dataCollection',
            meta: { hightRoute: '/home/analytical/deepInsight' },
            component: () => import('./report/pages/DataCollection.vue'),
          },
          {
            path: 'analysis-report',
            name: 'analytical-analysis-report',
            meta: { hightRoute: '/home/analytical/deepInsight' },
            component: () => import('./report/analysis/AnalysisReportPageV3.vue'),
          },
          {
            path: 'analysis-report-v2',
            name: 'analytical-analysis-report-v2',
            meta: { hightRoute: '/home/analytical/deepInsight' },
            component: () => import('./report/analysis/AnalysisReportPageV3.vue'),
          },
        ],
      },
      {
        path: 'workbench',
        name: 'home-workbench',
        component: () => import('./pages/main-page/MainPage.vue'),
      },
      {
        path: 'aiTrack',
        name: 'home-aiTrack',
        component: () => import('./pages/ai-track/AiTrackPage.vue'),
      },
      {
        path: 'industryInsight',
        name: 'home-industryInsight',
        component: () => import('./pages/industry-insight/IndustryInsightPage.vue'),
      },
      {
        path: 'equity-detail',
        name: 'home-equity-detail',
        component: () => import('./pages/equity-detail/EquityDetailPage.vue'),
      },
      {
        path: 'sourceInsight',
        name: 'home-sourceInsight',
        component: () => import('./pages/source-insight/SourceInsightPage.vue'),
      },
      {
        path: 'knowledge',
        name: 'home-knowledge',
        redirect: '/home/knowledge/index',
        component: () => import('./knowledge/KnowledgePage.vue'),
        children: [
          {
            path: 'index',
            name: 'home-knowledge-index',
            component: () => import('./knowledge/pages/IndexPage.vue'),
          },
          {
            path: 'resource',
            name: 'home-knowledge-resource',
            component: () => import('./knowledge/pages/ResourcePage.vue'),
          },
          {
            path: 'command',
            name: 'home-knowledge-command',
            component: () => import('./knowledge/pages/CommandPage.vue'),
          },
          {
            path: 'commandCreate',
            name: 'home-knowledge-commandCreate',
            meta: {
              hightRoute: '/home/knowledge/command',
            },
            component: () => import('./knowledge/pages/CommandCreatePage.vue'),
          },
          {
            path: 'prompt',
            name: 'home-knowledge-prompt',
            component: () => import('./knowledge/pages/PromptPage.vue'),
          },
        ],
      },
      {
        path: 'media',
        name: 'home-media',
        redirect: '/home/media/task',
        component: () => import('./media/MediaPage.vue'),
        children: [
          {
            path: 'task',
            name: 'home-media-task',
            component: () => import('./media/pages/MediaTask.vue'),
          },
          {
            path: 'manage',
            name: 'home-media-manage',
            component: () => import('./media/pages/MediaManage.vue'),
          },
          {
            path: 'video',
            name: 'home-media-video',
            component: () => import('./media/pages/VideoManage.vue'),
          },
          {
            path: 'articlePublishing',
            name: 'home-media-articlePublishing',
            component: () => import('./media/pages/ArticlePublishing.vue'),
          },
        ],
      },
      {
        path: 'statistical',
        name: 'home-statistical',
        redirect: '/home/statistical/data',
        component: () => import('./statistical/StatisticalPage.vue'),
        children: [
          {
            path: 'account',
            name: 'home-statistical-account',
            component: () => import('./statistical/pages/Account.vue'),
          },
          {
            path: 'send',
            name: 'home-statistical-send',
            component: () => import('./statistical/pages/SendRecord.vue'),
          },
          {
            path: 'data',
            name: 'home-statistical-data',
            component: () => import('./statistical/pages/DataPage.vue'),
          },
          {
            path: 'month',
            name: 'home-statistical-month',
            component: () => import('./statistical/pages/MonthPage.vue'),
          },
        ],
      },
      {
        path: 'zmt-noRight',
        name: 'home-zmt-noRight',
        component: () => import('./rights-guide/GuideMedia.vue'),
      },
    ],
  },
  {
    path: 'weekly',
    name: 'weeklyReport',
    meta: { skipAuth: true },
    component: () => import('./weekly/WeeklyReport.vue'),
  },
  {
    path: 'report',
    name: 'brandReport',
    meta: { skipAuth: true },
    component: () => import('./report/BrandReport.vue'),
  },
  {
    path: 'analysis-report',
    name: 'analysisReport',
    meta: { skipAuth: true },
    component: () => import('./report/analysis/AnalysisReportPageV3.vue'),
  },
  {
    path: 'analysis-report/print',
    name: 'analysisReportPrint',
    meta: { printOnly: true },
    component: () => import('./report/analysis/AnalysisReportPrintPage.vue'),
  },
]
